import { OrderImportColumnMappingSchema } from "@redotech/redo-fulfillment-common/import-schema";
import * as z from "zod";

export const saveCustomImportSchema = {
  name: "saveCustomImportSchema" as const,
  input: z.object({
    id: z.string().optional(),
    name: z.string().min(1),
    columnMapping: OrderImportColumnMappingSchema,
  }),
  output: z.object({ id: z.string() }),
};
